skrilla.service('paginationService', function(){
    var page = {};
    var getPage = function(key){
        if(key !== null && key !== undefined){
            if(page[key] === null || page[key] === undefined){
                page[key] = {totalEntities: 0, offset: 0};
            }
            return page[key];
        }else{
            return null;
        }
    }

    var resetPage = function(key){
        if(page[key] != null){
            page[key].offset = 0;
            page[key].totalEntities = 0;
            page[key].currentPage = 0;
        }
        else{
            page[key] = {totalEntities: 0, offset: 0, currentPage: 0};
        }
    }
    var setPage = function(key, data){
        if(key != null && data != null){
            if(page[key] == null) page[key] = {};
            page[key].offset = data.offset;
            page[key].totalEntities = data.totalEntities;
            page[key].limit = data.limit;
        }
    }
    var buildPage = function(response){
        return {totalEntities: response.data.totalEntities, offset: response.data.query.offset, limit: response.data.query.limit};
    }

    var pageQuery = function(query, key){
        return query().then(function(response){
            page[key].query = query;
            callPageUpdateListner(key);
            return response;
        });
    }

    var pageUpdateListener = function(fn, key){
        if(fn != null && key != null && page[key] != null){
            page[key].updateListner = fn;
        }
    }

    var callPageUpdateListner = function(key){
        if(page[key] != null && page[key].updateListner !== undefined){
            page[key].updateListner();
        }
    }

    return {
        getPage: getPage,
        setPage: setPage,
        resetPage: resetPage,
        pageQuery: pageQuery,
        buildPage: buildPage,
        pageUpdateListener: pageUpdateListener
    };
});

